import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { DayOfWeek, FirstWeekOfYear } from 'office-ui-fabric-react/lib/DatePicker';
import { ConstrainMode, DetailsList, Selection, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { getId } from 'office-ui-fabric-react/lib/Utilities';
import React, { Component, Fragment } from 'react';
import Scriba from 'react-scriba';
import { DataJournalisation } from '../../data/DataJournalisation';
import { MaxLengths } from '../../data/MaxLenghts';
import { EUIDatePicker } from '../EUI/EUIDatePicker';
import { EUITextField } from '../EUI/EUITextField';
import { FicheJournalisation } from '../Fiche/FicheJournalisation';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';
import './DetailsListJournalisation.css';

/*
***************************************************************
 PROPS: none
***************************************************************
*/

export class DetailsListJournalisation extends Component {
    _selection;

    _creationContent() {
        const { items } = this.state;

        return (<DetailsList
            columns={this.state.columns}
            constrainMode={ConstrainMode.unconstrained}
            items={items}
            onColumnHeaderClick={this._onClickColumnHeader}
            onRenderDetailsHeader={this._onRenderDetailsHeader}
            selection={this._selection}
            selectionMode={SelectionMode.multiple}
        />);
    }

    constructor(props) {
        super(props);
        const now = new Date();
        const columns = [
            {
                key: 'show',
                iconName: null,
                isIconOnly: true,
                minWidth: 25,
                maxWidth: 25,
                name: 'Consulter',
                onRender: (item) => {
                    return <IconButton
                        ariaLabel="Consulter le journal"
                        iconProps={{ iconName: 'NewsSearch' }}
                        onClick={() => this._onClickOpenFicheJournalisation(item, item.idJournalisation)}
                        title="Consulter le journal"
                    />;
                }
            },
            {
                className: 'ms-hiddenLgDown',
                headerClassName: 'ms-hiddenLgDown',
                isSorted: true,
                isSortedDescending: false,
                key: 'idJournalisation',
                minWidth: 55,
                maxWidth: 55,
                name: 'ID',
                onRender: (item) => {
                    let idJournalisation = item.idJournalisation;
                    return <span title={idJournalisation} className="badge badge-secondary">{idJournalisation}</span>;
                }
            },
            {
                className: 'ms-hiddenXlDown',
                headerClassName: 'ms-hiddenXlDown',
                isResizable: true,
                key: 'fonctionnalite',
                minWidth: 100,
                maxWidth: 150,
                name: 'Fonctionnalité',
                onRender: (item) => {
                    let fonctionnalite = item.fonctionnalite;
                    return <span title={fonctionnalite}>{fonctionnalite}</span>;
                }
            },
            {
                className: 'ms-hiddenMdDown',
                headerClassName: 'ms-hiddenMdDown',
                isResizable: true,
                key: 'nomTable',
                minWidth: 100,
                maxWidth: 150,
                name: 'Table',
                onRender: (item) => {
                    let nomTable = item.nomTable;
                    return <span title={nomTable}>{nomTable}</span>;
                }
            },
            {
                className: 'ms-hiddenLgDown',
                headerClassName: 'ms-hiddenLgDown',
                isMultiline: true,
                isResizable: true,
                key: 'idOperation',
                minWidth: 100,
                maxWidth: 150,
                name: 'Opération',
                onRender: (item) => {
                    let idOperation = item.idOperation;
                    let nomCommercial = item.nomCommercial;
                    let displayedValue = "";
                    if (idOperation && nomCommercial) displayedValue = idOperation + " (" + nomCommercial + ")";
                    else if (idOperation) displayedValue = idOperation;
                    else if (nomCommercial) displayedValue = nomCommercial;
                    return <span title={idOperation}>{displayedValue}</span>;
                }
            },
            {
                className: 'ms-hiddenXlDown',
                headerClassName: 'ms-hiddenXlDown',
                isResizable: true,
                key: 'idLotCommercial',
                minWidth: 50,
                maxWidth: 100,
                name: 'Lot',
                onRender: (item) => {
                    let idLotCommercial = item.idLotCommercial;
                    let numero = item.numero;
                    let displayedValue = "";
                    if (idLotCommercial && numero) displayedValue = idLotCommercial + " (n° " + numero + ")";
                    else if (idLotCommercial) displayedValue = idLotCommercial;
                    else if (numero) displayedValue = numero;
                    return <span title={idLotCommercial}>{displayedValue}</span>;
                }
            },
            {
                className: 'ms-hiddenXlDown',
                headerClassName: 'ms-hiddenXlDown',
                isResizable: true,
                key: 'idContact',
                minWidth: 50,
                maxWidth: 100,
                name: 'Contact',
                onRender: (item) => {
                    let idContact = item.idContact;
                    return <span title={idContact}>{idContact}</span>;
                }
            },
            {
                isMultiline: true,
                isResizable: true,
                key: 'nomAction',
                minWidth: 100,
                maxWidth: 150,
                name: 'Action',
                onRender: (item) => {
                    let nomAction = item.nomAction;
                    return <span title={nomAction}>{nomAction}</span>;
                }
            },
            {
                className: 'ms-hiddenXlDown',
                headerClassName: 'ms-hiddenXlDown',
                isResizable: true,
                key: 'loginCompte',
                minWidth: 100,
                maxWidth: 150,
                name: 'Commercialisateur',
                onRender: (item) => {
                    let loginCompte = item.loginCompte;
                    return <span title={loginCompte}>{loginCompte}</span>;
                }
            },
            {
                className: 'ms-hiddenSm',
                headerClassName: 'ms-hiddenSm',
                isResizable: true,
                key: 'creerPar',
                minWidth: 100,
                maxWidth: 150,
                name: 'Utilisateur',
                onRender: (item) => {
                    let creerPar = item.creerPar;
                    return <span title={creerPar}>{creerPar}</span>;
                }
            },
            {
                isFiltered: true,
                isResizable: true,
                key: 'creerLe',
                minWidth: 100,
                maxWidth: 150,
                name: 'Date',
                onRender: (item) => {
                    let creerLe = item.creerLe;
                    return <span title={creerLe}>{Scriba.date().stringDateHeureFormatCourt(Scriba.date().getDateFromChaineISO(creerLe))}</span>;
                }
            },
            {
                className: 'ms-hiddenLgDown',
                headerClassName: 'ms-hiddenLgDown',
                key: 'origine',
                minWidth: 50,
                maxWidth: 50,
                name: 'Origine',
                onRender: (item) => {
                    let origine = item.origine;
                    let shortenedOrigine = origine && origine.length > 3 ? origine.substring(0, 3) : origine;
                    return <span title={origine}>{shortenedOrigine}</span>;
                }
            },
            {
                className: 'ms-hiddenLgDown',
                headerClassName: 'ms-hiddenLgDown',
                key: 'immoFactory',
                minWidth: 20,
                maxWidth: 25,
                name: 'IF',
                onRender: (item) => {
                    return (item.immoFactory ? <Icon iconName="FullCircleMask" className="icon" /> : null);
                }
            },
            {
                className: 'ms-hiddenLgDown',
                headerClassName: 'ms-hiddenLgDown',
                key: 'priseEnCompteLe',
                minWidth: 20,
                maxWidth: 25,
                name: 'PEC',
                onRender: (item) => {
                    const priseEnCompteLe = item.priseEnCompteLe;
                    return (priseEnCompteLe ?
                        <TooltipHost
                            content={"Prise en compte le " + Scriba.date().stringDateHeureFormatCourt(Scriba.date().getDateFromChaineISO(priseEnCompteLe))}
                            id={this._hostId}
                            calloutProps={{ gapSpace: 0 }}
                            styles={{ root: { display: 'inline-block' } }}
                        >
                            <Icon iconName="CompletedSolid" className="icon successIcon helpCursor" aria-describedby={this._hostId} />
                        </TooltipHost> : null);
                }
            },
            {
                className: 'ms-hiddenLgDown',
                headerClassName: 'ms-hiddenLgDown',
                key: 'traiteeLe',
                minWidth: 20,
                maxWidth: 25,
                name: 'T',
                onRender: (item) => {
                    const traiteeLe = item.traiteeLe;
                    return (traiteeLe ?
                        <TooltipHost
                            content={"Traitée le " + Scriba.date().stringDateHeureFormatCourt(Scriba.date().getDateFromChaineISO(traiteeLe))}
                            id={this._hostId}
                            calloutProps={{ gapSpace: 0 }}
                            styles={{ root: { display: 'inline-block' } }}
                        >
                            <Icon iconName="CompletedSolid" className="icon successIcon helpCursor" aria-describedby={this._hostId} />
                        </TooltipHost> : null);
                }
            },
            {
                className: 'ms-hiddenMdDown',
                headerClassName: 'ms-hiddenMdDown',
                key: 'immoFactoryCommentaire',
                minWidth: 20,
                maxWidth: 25,
                name: 'EIF',
                onRender: (item) => {
                    const immoFactoryCommentaire = item.immoFactoryCommentaire;
                    const [iconName, className] = /^([24]003|[67]001)/.test(immoFactoryCommentaire) ? ["AlertSolid", "icon infoIcon helpCursor"] : ["StatusErrorFull", "icon errorIcon helpCursor"]; // SI code renvoyé = 2003 | 4003 | 6001 | 7001 ALORS alerte SINON erreur
                    return (immoFactoryCommentaire ?
                        <TooltipHost
                            content={immoFactoryCommentaire}
                            id={this._hostId}
                            calloutProps={{ gapSpace: 0 }}
                            styles={{ root: { display: 'inline-block' } }}
                        >
                            <Icon iconName={iconName} className={className} aria-describedby={this._hostId} />
                        </TooltipHost> : null);
                }
            },
            {
                className: 'ms-hiddenMdDown',
                headerClassName: 'ms-hiddenMdDown',
                key: 'erreurEI',
                minWidth: 20,
                maxWidth: 25,
                name: 'EEI',
                onRender: (item) => {
                    return (item.erreurEI ?
                        <TooltipHost
                            content="Consultez le journal pour plus de détails"
                            id={this._hostId}
                            calloutProps={{ gapSpace: 0 }}
                            styles={{ root: { display: 'inline-block' } }}
                        >
                            <Icon iconName="StatusErrorFull" className="icon errorIcon helpCursor" aria-describedby={this._hostId} />
                        </TooltipHost> : null);
                }
            }
        ];

        this._selection = new Selection({
            onSelectionChanged: () => { this.setState({ selectedJournalisations: this._selection.getSelection() }); },
            canSelectItem: this._canSelectJournalisation
        });
        this.state = {
            items: [],
            columns: columns,
            displayedJournalisation: {},
            selectedJournalisations: [],
            enCoursDeTraitement: false,
            messageEnCoursTraitement: '',
            isOpenFicheJournalisation: false,
            isOpenPanelFiltre: false,
            hideMessageBarFiltres: true,
            hideMessageBarWarning: true,
            hideMessageBarError: true,
            warningMessage: '',
            errorMessage: '',
            messageMessageBarFiltres: '',

            filtreIdJournalisationMin: "",
            filtreIdJournalisationMax: "",
            filtreNomTable: null,
            filtreCreerPar: "",
            filtreFromDate: Scriba.date().dateForceFormatUTC(new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())),
            filtreToDate: Scriba.date().dateForceFormatUTC(new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())),
            filtreIdOperation: "",
            filtreIdLot: "",
            filtreIdContact: "",
            filtreIdReservation: "",
            filtreImmoFactory: null,
            filtrePriseEnCompteLe: null,
            filtreTraiteeLe: null,
            filtreErreurIF: null,
            filtreErreurEI: null,
            recherche: "",
            pageIndex: 1,
            nbEnregistrementsParPage: 500,
            sortedColumn: "",
            isSortedDescending: true
        };
    }

    _canSelectJournalisation = (item) => {
        return 'priseEnCompteLe' in item;
    };
    _chargementDonnees = () => {
        if (!this.state.enCoursDeTraitement) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Chargement des journaux en cours'
            });

            let chargementDesJournalisations = DataJournalisation._chargementDesJournalisations(this.state.filtreIdJournalisationMin, this.state.filtreIdJournalisationMax,
                this.state.filtreNomTable, this.state.filtreCreerPar, this.state.filtreFromDate, this.state.filtreToDate, this.state.filtreIdOperation, this.state.filtreIdLot,
                this.state.filtreIdContact, this.state.filtreIdReservation, this.state.filtreImmoFactory, this.state.filtrePriseEnCompteLe, this.state.filtreTraiteeLe, this.state.filtreErreurIF,
                this.state.filtreErreurEI, this.state.recherche, this.state.pageIndex, this.state.nbEnregistrementsParPage, this.state.tri, this.state.sortedColumn, this.state.isSortedDescending);

            chargementDesJournalisations
                .then(responseFetch => {
                    const retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);
                    let newState = {
                        enCoursDeTraitement: false,
                        messageEnCoursTraitement: '',
                        hideMessageBarWarning: retourVerif.hideMessageBarWarning,
                        warningMessage: retourVerif.warningMessage,
                        hideMessageBarError: retourVerif.hideMessageBarError,
                        errorMessage: retourVerif.errorMessage
                    };
                    if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {

                        let newItems = [];

                        //YD : 17/06/2020 : Ajout test sur listeItem != null
                        let listeItem = (responseFetch.reponseAPIobjet !== null ? responseFetch.reponseAPIobjet : []);

                        if (this.state.pageIndex === 1) {
                            newItems = listeItem;
                        }
                        else {
                            newItems = this.state.items;
                            newItems = newItems.concat(listeItem);

                            //if (responseFetch.reponseAPIobjet.length === 0) newState.pageIndex = 0; // Arrêt du lazy loading
                            //newItems = this.state.items.concat(responseFetch.reponseAPIobjet);
                        }
                        newState.items = newItems;
                    };

                    this.setState(newState);
                });
        }
    };
    _getFarItems = () => {
        return [
            {
                key: 'nombreEnregistrement',
                name: (this.state.items != null ? this.state.items.length : 0)
            },
            {
                key: 'filtre',
                iconOnly: true,
                iconProps: {
                    iconName: 'Filter'
                },
                name: 'Filtres',
                onClick: () => this._onClickOpenPanelFiltres()
            }
        ];
    };
    _getItems = () => {
        return [
            {
                key: 'search',
                onRender: () => <SearchBox
                    className="searchBox"
                    placeholder="Recherche rapide"
                    onClear={(e) => this._onSearch('')}
                    onSearch={(value) => this._onSearch(value)}
                />
            },
            {
                disabled: this._selection.getSelectedCount() <= 0,
                iconProps: { iconName: 'Undo' },
                key: 'reset',
                name: 'Réinclure dans la prochaine synchro.',
                onClick: () => this._onClickRemiseEnAttenteTraitementIF()
            }
        ];
    };
    _hostId = getId('tooltipHost');
    _reinitFiltre = () => {
        const now = new Date();
        this.setState({
            filtreIdJournalisationMin: "",
            filtreIdJournalisationMax: "",
            filtreNomTable: null,
            filtreCreerPar: "",
            filtreFromDate: Scriba.date().dateForceFormatUTC(new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())),
            filtreToDate: Scriba.date().dateForceFormatUTC(new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())),
            filtreIdOperation: "",
            filtreIdLot: "",
            filtreIdContact: "",
            filtreIdReservation: "",
            filtreImmoFactory: null,
            filtrePriseEnCompteLe: null,
            filtreTraiteeLe: null,
            filtreErreurIF: null,
            filtreErreurEI: null,
            pageIndex: 1,
            nbEnregistrementsParPage: 500
        });
    };

    _onBlurFiltreIdJournalisationMax = (value) => {
        if (value != null && value != "") {
            const filtreIdJournalisationMin = this.state.filtreIdJournalisationMin;
            if (filtreIdJournalisationMin && parseInt(filtreIdJournalisationMin) > value) {
                this.setState({ filtreIdJournalisationMin: value });
            } else {
                this.setState({ filtreIdJournalisationMax: value });
            }
        }
    };
    _onBlurFiltreIdJournalisationMin = (value) => {
        if (value != null && value != "") {
            const filtreIdJournalisationMax = this.state.filtreIdJournalisationMax;
            if (filtreIdJournalisationMax && parseInt(filtreIdJournalisationMax) < value) {
                this.setState({ filtreIdJournalisationMax: value });
            } else {
                this.setState({ filtreIdJournalisationMin: value });
            }
        }
    };
    _onClickApplyFiltres = () => {
        this.setState({
            isOpenPanelFiltre: false,
            pageIndex: 1
        }, () => this._chargementDonnees());
    };
    _onClickColumnHeader = (ev, column) => {
        const key = column.key;
        if (!['idOperation', 'idLotCommercial', 'idContact', 'loginCompte'].includes(key)) { // Annuler le tri sur des colonnes construites à partir d'IdsTable
            const { columns } = this.state;
            const newColumns = columns.slice();
            const currColumn = newColumns.filter(currCol => column.key === currCol.key)[0];
            newColumns.forEach((newCol) => {
                if (newCol === currColumn) {
                    currColumn.isSortedDescending = !currColumn.isSortedDescending;
                    currColumn.isSorted = true;
                } else {
                    newCol.isSorted = false;
                    newCol.isSortedDescending = false;
                }
            });
            this.setState({
                pageIndex: 1,
                sortedColumn: key,
                isSortedDescending: (typeof column.isSortedDescending !== 'undefined' && column.isSortedDescending)
            }, () => this._chargementDonnees());
        }
    };
    _onClickOpenFicheJournalisation = (displayedJournalisation) => {
        this.setState({
            displayedJournalisation: displayedJournalisation,
            isOpenFicheJournalisation: true,
            isOpenPanelFiltre: false
        });
    };
    _onClickOpenPanelFiltres = () => {
        this.setState({
            isOpenFicheJournalisation: false,
            isOpenPanelFiltre: true
        });
    };
    _onClickRemiseEnAttenteTraitementIF = () => {
        if (!this.state.enCoursDeTraitement) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Réabonnement à la synchro. IF en cours'
            });
            let idsJournalisations = [];
            this.state.selectedJournalisations.forEach(journalisation => {
                idsJournalisations.push(journalisation.idJournalisation);
            });

            let onRemiseEnAttenteTraitementIF = DataJournalisation._onRemiseEnAttenteTraitementIF(idsJournalisations);

            onRemiseEnAttenteTraitementIF
                .then(responseFetch => {
                    const retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);
                    this.setState({
                        enCoursDeTraitement: false,
                        messageEnCoursTraitement: '',
                        hideMessageBarWarning: retourVerif.hideMessageBarWarning,
                        warningMessage: retourVerif.warningMessage,
                        hideMessageBarError: retourVerif.hideMessageBarError,
                        errorMessage: retourVerif.errorMessage
                    }, () => this._chargementDonnees());
                });

        }
    };
    _onChangeFiltreErreurEI = (event, option, index) => { this.setState({ filtreErreurEI: (option.key === 0 ? null : option.key) }); };
    _onChangeFiltreErreurIF = (event, option, index) => { this.setState({ filtreErreurIF: (option.key === 0 ? null : option.key) }); };
    _onChangeFiltreIdContact = (event, newValue) => {
        if (!newValue || newValue >>> 0 === parseFloat(newValue)) { // Si newValue de type integer
            this.setState({ filtreIdContact: newValue || '' }); // Alors valider la saisie
        } else {
            this.setState({ filtreIdContact: this.state.filtreIdContact });
        }
    };
    _onChangeFiltreIdJournalisationMax = (event, newValue) => {
        if (!newValue || newValue >>> 0 === parseFloat(newValue)) { // Si newValue de type integer
            this.setState({ filtreIdJournalisationMax: parseInt(newValue) || null }); // Alors valider la saisie
        } else {
            this.setState({ filtreIdJournalisationMax: this.state.filtreIdJournalisationMax });
        }
    };
    _onChangeFiltreIdJournalisationMin = (event, newValue) => {
        if (!newValue || newValue >>> 0 === parseFloat(newValue)) { // Si newValue de type integer
            this.setState({ filtreIdJournalisationMin: parseInt(newValue) || null }); // Alors valider la saisie
        } else {
            this.setState({ filtreIdJournalisationMin: this.state.filtreIdJournalisationMin });
        }
    };
    _onChangeFiltreIdOperation = (event, newValue) => {
        if (!newValue || newValue >>> 0 === parseFloat(newValue)) { // Si newValue de type integer
            this.setState({ filtreIdOperation: newValue || '' }); // Alors valider la saisie
        } else {
            this.setState({ filtreIdOperation: this.state.filtreIdOperation });
        }
    };
    _onChangeFiltreIdLot = (event, newValue) => {
        if (!newValue || newValue >>> 0 === parseFloat(newValue)) { // Si newValue de type integer
            this.setState({ filtreIdLot: newValue || '' }); // Alors valider la saisie
        } else {
            this.setState({ filtreIdLot: this.state.filtreIdLot });
        }
    };
    _onChangeFiltreIdReservation = (event, newValue) => {
        if (!newValue || newValue >>> 0 === parseFloat(newValue)) { // Si newValue de type integer
            this.setState({ filtreIdReservation: newValue || '' }); // Alors valider la saisie
        } else {
            this.setState({ filtreIdReservation: this.state.filtreIdReservation });
        }
    };
    _onChangeFiltreImmoFactory = (event, option, index) => { this.setState({ filtreImmoFactory: (option.key === 0 ? null : option.key) }); };
    _onChangeFiltreLoginCompte = (event, newValue) => {
        this.setState({ filtreCreerPar: newValue });
    };
    _onChangeFiltreNomTable = (event, option, index) => { this.setState({ filtreNomTable: (option.key === 0 ? null : option.key) }); };
    _onChangeFiltrePriseEnCompteLe = (event, option, index) => { this.setState({ filtrePriseEnCompteLe: (option.key === 0 ? null : option.key) }); };
    _onChangeFiltreTraiteeLe = (event, option, index) => { this.setState({ filtreTraiteeLe: (option.key === 0 ? null : option.key) }); };
    _onDismissFicheJournalisation = () => {
        this.setState({
            displayedJournalisation: {},
            isOpenFicheJournalisation: false
        });
    };
    _onDismissPanelFiltres = () => {
        this.setState({
            isOpenPanelFiltre: false
        });
    };
    _onRenderDetailsHeader = (props, defaultRender) => {
        return (
            <div>
                <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
                    {defaultRender({
                        ...props,
                        onRenderColumnHeaderTooltip: (tooltipHostProps) => <TooltipHost {...tooltipHostProps} />
                    })}
                </Sticky>
            </div>
        );
    }
    _onRenderFiltresFooterContent = () => {
        return (
            <div>
                <PrimaryButton onClick={this._onClickApplyFiltres} className="marginRight8px">Valider</PrimaryButton>
                <DefaultButton onClick={this._onDismissPanelFiltres}>Fermer</DefaultButton>
            </div>
        );
    };
    //_onRenderFiltresHeader = () => {
    //    return (
    //        <div className="custom-ms-Panel-header">
    //            <span>Filtres</span>
    //            <IconButton
    //                ariaLabel="Réinitialiser les filtres"
    //                iconProps={{ iconName: 'ClearFilter' }}
    //                title="Réinitialiser les filtres"
    //                onClick={() => { this._clearFiltres(); }}
    //            />
    //        </div>
    //    );
    //};
    _onScroll = (e) => {
        if ((e.target.scrollHeight - e.target.clientHeight) === (Math.trunc(e.target.scrollTop)) && this.state.pageIndex > 0) {
            this.setState(
                { pageIndex: this.state.pageIndex + 1 },
                () => this._chargementDonnees()
            );
        }
    }
    _onSearch = (text) => {
        this.setState({
            pageIndex: 1,
            recherche: text
        }, () => this._chargementDonnees());
    }
    _onSelectFiltreFromDate = (date) => {
        const dateToUTC = Scriba.date().dateForceFormatUTC(date);
        this.setState({ filtreFromDate: dateToUTC });
        if (dateToUTC.getTime() > this.state.filtreToDate.getTime())
            this.setState({ filtreToDate: dateToUTC }); // filtreFromDate ne peut être supérieur à filtreToDate
    };
    _onSelectFiltreToDate = (date) => {
        const dateToUTC = Scriba.date().dateForceFormatUTC(date);
        this.setState({ filtreToDate: dateToUTC });
        if (dateToUTC.getTime() < this.state.filtreFromDate.getTime())
            this.setState({ filtreFromDate: dateToUTC }); // filtreFromDate ne peut être supérieur à filtreToDate
    };

    componentDidMount() {
        this._chargementDonnees();
    };
    componentDidUpdate() { };

    componentWillUnmount() { };

    render = () => {

        const content = this._creationContent();

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <CommandBar
                    ariaLabel={"Utiliser les flèches droite et gauche pour naviguer"}
                    farItems={this._getFarItems()}
                    items={this._getItems()}
                    overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                />
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <div className="position-relative h-100">
                    <ScrollablePane
                        onScroll={this._onScroll}
                        scrollbarVisibility={ScrollbarVisibility.auto}
                    >
                        {content}
                    </ScrollablePane>
                </div>
            </Stack>

            <Panel
                isOpen={this.state.isOpenPanelFiltre}
                type={PanelType.smallFixedFar}
                onDismiss={this._onDismissPanelFiltres}
                headerText="Filtres"
                closeButtonAriaLabel="Close"
                onRenderFooterContent={this._onRenderFiltresFooterContent}
            >
                <Stack>
                    <div className="buttonFiltres">
                        <IconButton
                            iconProps={{ iconName: 'ClearFilter' }}
                            className="buttonFiltres"
                            title="Réinitialiser les filtres"
                            ariaLabel="Filtres"
                            onClick={() => this._reinitFiltre()}
                        />
                    </div>
                    <EUIDatePicker
                        isRequired
                        label="A compter du"
                        onSelectDate={this._onSelectFiltreFromDate}
                        value={this.state.filtreFromDate}
                    />
                    <EUIDatePicker
                        isRequired
                        label="Jusqu'au"
                        onSelectDate={this._onSelectFiltreToDate}
                        value={this.state.filtreToDate}
                    />
                    <EUITextField
                        label="Login utilisateur"
                        maxLength={MaxLengths.contact.creerPar}
                        onChange={this._onChangeFiltreLoginCompte}
                        value={this.state.filtreCreerPar}
                    />
                    <Dropdown
                        defaultSelectedKey={this.state.filtreNomTable === null ? 0 : this.state.filtreNomTable}
                        label="Nature de l'action"
                        onChange={this._onChangeFiltreNomTable}
                        options={[
                            { key: 0, text: 'Indifférent' },
                            { key: true, text: 'En base uniquement' },
                            { key: false, text: 'Applicatives uniquement' },
                        ]}
                    />
                    <TextField // Note KP : TextFieldNombre en cours de test
                        ariaLabel="ID minimum du journal"
                        label="ID log min."
                        onBlur={(e) => this._onBlurFiltreIdJournalisationMin(e.target.value)}
                        onChange={this._onChangeFiltreIdJournalisationMin}
                        validateOnFocusOut={true}
                        value={this.state.filtreIdJournalisationMin}
                    />
                    <TextField // Note KP : TextFieldNombre en cours de test
                        ariaLabel="ID maximum du journal"
                        label="ID log max."
                        onBlur={(e) => this._onBlurFiltreIdJournalisationMax(e.target.value)}
                        onChange={this._onChangeFiltreIdJournalisationMax}
                        validateOnFocusOut={true}
                        value={this.state.filtreIdJournalisationMax}
                    />
                    <TextField // Note KP : TextFieldNombre en cours de test
                        ariaLabel="ID de l'opération"
                        label="ID de l'opération"
                        onChange={this._onChangeFiltreIdOperation}
                        value={this.state.filtreIdOperation}
                    />
                    <TextField // Note KP : TextFieldNombre en cours de test
                        ariaLabel="ID du lot"
                        label="ID du lot"
                        onChange={this._onChangeFiltreIdLot}
                        value={this.state.filtreIdLot}
                    />
                    <TextField // Note KP : TextFieldNombre en cours de test
                        ariaLabel="ID du contact"
                        label="ID du contact"
                        onChange={this._onChangeFiltreIdContact}
                        value={this.state.filtreIdContact}
                    />
                    <TextField // Note KP : TextFieldNombre en cours de test
                        ariaLabel="ID de la réservation"
                        label="ID de la réservation"
                        onChange={this._onChangeFiltreIdReservation}
                        value={this.state.filtreIdReservation}
                    />
                    <Dropdown
                        defaultSelectedKey={this.state.filtreImmoFactory === null ? 0 : this.state.filtreImmoFactory}
                        label="Source Immo Factory ?"
                        onChange={this._onChangeFiltreImmoFactory}
                        options={[
                            { key: 0, text: 'Indifférent' },
                            { key: true, text: 'Oui' },
                            { key: false, text: 'Non' },
                        ]}
                    />
                    <Dropdown
                        defaultSelectedKey={this.state.filtrePriseEnCompteLe === null ? 0 : this.state.filtrePriseEnCompteLe}
                        label="Synchro. prises en compte ?"
                        onChange={this._onChangeFiltrePriseEnCompteLe}
                        options={[
                            { key: 0, text: 'Indifférent' },
                            { key: true, text: 'Oui' },
                            { key: false, text: 'Non' },
                        ]}
                    />
                    <Dropdown
                        defaultSelectedKey={this.state.filtreTraiteeLe === null ? 0 : this.state.filtreTraiteeLe}
                        label="Synchro. traitées ?"
                        onChange={this._onChangeFiltreTraiteeLe}
                        options={[
                            { key: 0, text: 'Indifférent' },
                            { key: true, text: 'Oui' },
                            { key: false, text: 'Non' },
                        ]}
                    />
                    <Dropdown
                        defaultSelectedKey={this.state.filtreErreurIF === null ? 0 : this.state.filtreErreurIF}
                        label="En erreur Immo Factory ?"
                        onChange={this._onChangeFiltreErreurIF}
                        options={[
                            { key: 0, text: 'Indifférent' },
                            { key: true, text: 'Oui' },
                            { key: false, text: 'Non' },
                        ]}
                    />
                    <Dropdown
                        defaultSelectedKey={this.state.filtreErreurEI === null ? 0 : this.state.filtreErreurEI}
                        label="En erreur Immocom ?"
                        onChange={this._onChangeFiltreErreurEI}
                        options={[
                            { key: 0, text: 'Indifférent' },
                            { key: true, text: 'Oui' },
                            { key: false, text: 'Non' },
                        ]}
                    />
                </Stack>
            </Panel>

            <FicheJournalisation
                isOpen={this.state.isOpenFicheJournalisation}
                journalisation={this.state.displayedJournalisation}
                onDismiss={() => this._onDismissFicheJournalisation()}
            />

        </Fragment>;
    };
};